export * from './ClipboardIcon';
